
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import Pricing from "./pages/Pricing";
import Features from "./pages/Features";
import HowItWorks from "./pages/HowItWorks";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import GleamAlternative from "./pages/GleamAlternative";

import ContestPage from "./pages/ContestPage";
import ScrollToTop from "./components/ScrollToTop";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ContestAdmin from "./pages/admin/ContestAdmin";
import ContestEmails from "./pages/admin/ContestEmails";
import ContestForm from "./pages/admin/ContestForm";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminAbuse from "./pages/admin/Abuse";
import AdminAnalytics from "./pages/admin/Analytics";
import NotFound from "./pages/NotFound";
import AdminLayout from "./layouts/AdminLayout";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/gleam-alternative" element={<GleamAlternative />} />
          <Route path="/login" element={<Navigate to="/admin?mode=login" replace />} />
          <Route path="/signup" element={<Navigate to="/admin?mode=signup" replace />} />
          <Route path="/c/:slug" element={<ContestPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/abuse" element={<AdminAbuse />} />
            <Route path="/admin/contests/new" element={<ContestForm />} />
            <Route path="/admin/contests/:slug" element={<ContestAdmin />} />
            <Route path="/admin/contests/:slug/emails" element={<ContestEmails />} />
            <Route path="/admin/contests/:slug/edit" element={<ContestForm />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
